import React from 'react';
import BoschIcon from './BoschIcon.js';
import ContactTeaserContactType from './ContactTeaserContactType.js';
const ContactTeaserCard = ({
  subheadline = '',
  icon = null,
  iconSrText = '',
  description = null,
  contactType = []
}) => {
  const propertyIcon = icon ? /*#__PURE__*/React.createElement(BoschIcon, {
    icon: icon,
    srText: iconSrText
  }) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "ebds-contact-teaser__card-content"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "ebds-contact-teaser__card-content__subheadline"
  }, subheadline), /*#__PURE__*/React.createElement("div", {
    className: "ebds-contact-teaser__card-content__icon"
  }, propertyIcon), /*#__PURE__*/React.createElement("div", {
    className: "ebds-contact-teaser__card-content__description"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "ebds-contact-teaser__card-content__contact-types"
  }, contactType.map(type => /*#__PURE__*/React.createElement(ContactTeaserContactType, Object.assign({
    key: type.contactData
  }, type)))));
};
export default ContactTeaserCard;